import { sessionStorageUtil } from "../utils/storage";

export async function getFundBankAccounts(data) {
  const token = sessionStorageUtil.getAccessToken();
  const code = sessionStorageUtil.getAmcCode();

  const { email, fund_code } = data;

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/account/by-fund?email=${encodeURIComponent(email)}&amc_code=${code}&fund_code=${encodeURIComponent(fund_code)}&status=active&app=true`,
      {
        method: "GET",
        headers: {
          Authorization: token,
        },
      },
    );

    const data = await response.json();

    // console.log(data);

    if (!response.ok || data?.status !== 200) {
      throw new Error(data?.message);
    }

    return {
      data: data?.data,
      message: data.message,
      error: false,
    };
  } catch (error) {
    // console.log(error);

    return {
      data: null,
      message: error?.message,
      error: true,
    };
  }
}

export async function getFundsByAmcCode(user) {
  const email = user ? user.data.email : process.env.REACT_APP_API_GUEST_EMAIL;
  const token = user ? sessionStorageUtil.getAccessToken() : process.env.REACT_APP_API_GUEST_TOKEN;

  const code = sessionStorageUtil.getAmcCode();

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/fund/by-amc-code-for-app?email=${encodeURIComponent(email)}&amc_code=${code}`, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    });

    const data = await response.json();

    if (!response.ok || data?.status !== 200) {
      throw new Error(data?.message);
    }

    return {
      data: data?.data,
      message: "Funds Fetched Successfully.",
      error: false,
    };
  } catch (error) {
    return {
      data: null,
      message: error?.message,
      error: true,
    };
  }
}

export async function getNavHistory(fund, from, to, signal) {

  const guest_email = process.env.REACT_APP_API_GUEST_EMAIL;
  const guest_token = process.env.REACT_APP_API_GUEST_TOKEN;

  const amc_code = sessionStorageUtil.getAmcCode();

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/fund/get-daily-nav-report?email=${guest_email}&amc_code=${amc_code}&fund=${fund}&from_date=${from}&to_date=${to}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': guest_token
      },
      signal
    })

    const data = await response.json();

    return {
      error: false,
      data,
      message: `Nav Data from ${from} to ${to} fetched successfully`
    }
  } catch(err) {
    // console.log(err);
    return {
      error: false,
      message: `Nav Data from ${from} to ${to} failed`
    }
  }
}
